var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-group',{attrs:{"show-arrows":""}},_vm._l((_vm.items),function(item){return _c('v-slide-item',{key:item.id},[_c('VideoPlayerDialog',{attrs:{"item":item,"width":"300","max-width":"300","metadata":"","imageClass":"mx-3"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }